module.exports = __webpack_public_path__ + "static/media/8.5d5fd755.png";